module.exports = __webpack_public_path__ + "static/img/choose.3bd09bd7.png";